import { Collapse } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  NotificationAlert,
  NotificationContentWrapper,
  StyledContent,
  StyledTitle,
} from '@/components/@IntranetLibrary/Notification/NotificationItem/styles';
import { useTheme } from '@emotion/react';
import { NotificationData } from '@/types/api';
import FaBellIcon from '@/public/icons/fa-bell.svg';

type NotificationItemProps = {
  onClose: () => void;
  handleOpen: (id: string) => void;
  openTalkFlowModal: (id: string) => void;
} & NotificationData;

const NotificationItem = ({
  title,
  body,
  link,
  onClose,
  handleOpen,
  openTalkFlowModal,
}: NotificationItemProps) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(true);

  const popToi = link.replace('//pop.', '//i.');

  // 자동 닫힘
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  // 닫기 로직
  const handleClose = () => {
    setIsOpen(false);
    setTimeout(onClose, 300); // transition 후 제거
  };

  // 클릭 로직 (WebView 제외)
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (link.includes('talkflow')) {
      handleClose();
      return openTalkFlowModal(link.split('/').pop() ?? '');
    }

    const isApproval = popToi.includes('approval');
    const docId = isApproval
      ? new URL(popToi).searchParams.get('doc') ?? ''
      : null;

    if (isApproval && docId) {
      handleOpen(docId);
    } else {
      window.open(popToi, '_blank', 'noopener,noreferrer');
    }
    handleClose();
  };

  return (
    <Collapse in={isOpen}>
      <div onClick={handleClick} style={{ cursor: 'pointer' }}>
        <NotificationAlert
          onClose={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
          }}
          icon={
            <FaBellIcon
              style={{
                width: '14px',
                height: '14px',
                color: theme.colors.primary,
              }}
            />
          }
        >
          <NotificationContentWrapper>
            <StyledTitle>{title}</StyledTitle>
            <StyledContent>{body}</StyledContent>
          </NotificationContentWrapper>
        </NotificationAlert>
      </div>
    </Collapse>
  );
};

export default NotificationItem;
